import * as Icons from '@cheqroom/icons';
import { IconKey } from '@cheqroom/ui';
import { FC, SVGProps } from 'react';

export const getIcon = (iconKey?: IconKey, fallbackToMarker = false): FC<SVGProps<SVGSVGElement>> | undefined => {
	if (!iconKey) {
		return fallbackToMarker ? Icons.Marker : undefined;
	}
	const icon = Icons[iconKey];
	return icon || (fallbackToMarker ? Icons.Marker : undefined);
};
